import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import moment from "moment";
import calendar from "../../../../assets/Calendar.svg";
import close from "../../../../assets/Close-Square.svg";
import pinLocation from "../../../../assets/Location.svg";
import { http } from "../../../../misc/http";

export default function ModalDetail({ isOpen, closeModal, id }) {
  const [organizer, setOrganizer] = useState({});
  const [dataKey, setDataKey] = useState([]);

  useEffect(() => {
    if (id) handleGetDetail();
  }, [id]);

  useEffect(() => {
    if (organizer._id)
      setDataKey([
        {
          key: "Nama Perusahaan",
          value: organizer.companyName,
        },
        {
          key: "No SK Pengakuan",
          value: organizer.noRef,
        },
        {
          key: "Alamat Website",
          value: organizer.website,
          type: "link",
        },
        {
          key: "Penanggung Jawab",
          value: organizer.PIC,
        },
        {
          key: "No Telepon",
          value: organizer.phone,
        },
        {
          key: "Jenis PSrE",
          value: organizer.type,
        },
        {
          key: "Status Pengakuan",
          value: organizer.status,
        },
        // {
        //   key: "Terdaftar Tanggal",
        //   value: moment(organizer.registerDate).format("DD-MM-YYYY"),
        // },
        // {
        //   key: "Masa Berlaku",
        //   value: `${moment(organizer.createdAt).format(
        //     "DD-MM-YYYY"
        //   )} s.d ${moment(organizer.expireDate).format("DD-MM-YYYY")}`,
        // },
      ]);
  }, [organizer]);

  const handleGetDetail = async () => {
    let params = {
      method: "GET",
      path: `organizer/${id}`,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) setOrganizer(data.data);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "70%",
      padding: 0,
      maxHeight: "80vh",
      overflow: "auto",
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="row">
        <div className="col-lg-6 col-12" style={{ padding: 50 }}>
          <h6 className="h6-nunito" style={{ fontWeight: "bold" }}>
            Daftar Penyelenggara Sertifikasi Elektronik Indonesia
          </h6>
          {dataKey.map((item) => (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                padding: "10px 0px",
                borderBottom: "2px solid #DADADA",
              }}
            >
              <p
                className="p-nunito"
                style={{ margin: 0, fontWeight: "bold", flex: 1 }}
              >
                {item.key}
              </p>
              <p
                className="p-nunito"
                style={{ marginBottom: 0, marginRight: 10 }}
              >
                :
              </p>
              {item.type == "link" ? (
                <a
                  href={item.value}
                  className="p-nunito"
                  style={{ margin: 0, flex: 2 }}
                >
                  {item.value}
                </a>
              ) : (
                <p className="p-nunito" style={{ margin: 0, flex: 2 }}>
                  {item.value}
                </p>
              )}
            </div>
          ))}
        </div>
        <div
          className="col-lg-6 col-12"
          style={{ backgroundColor: "#F9F9FA", padding: 50 }}
        >
          {organizer && organizer.histories && organizer.histories.length > 0 && (
            <>
              <h6
                className="h6-nunito"
                style={{ fontWeight: "bold", marginBottom: 20 }}
              >
                Riwayat Pengakuan
              </h6>
              <div style={{ height: "400px", overflow: "auto" }}>
                {organizer.histories.map((item, idx) => (
                  <>
                    <div style={{ display: "flex" }}>
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            height: "30%",
                            width: 2,
                            marginRight: 30,
                            marginLeft: 15,
                            backgroundColor: idx ? "#DADADA" : "#F9F9FA",
                          }}
                        />
                        <div
                          style={{
                            height: "70%",
                            width: 2,
                            marginRight: 30,
                            marginLeft: 15,
                            backgroundColor:
                              idx !== organizer.histories.length - 1
                                ? "#DADADA"
                                : "#F9F9FA",
                          }}
                        />
                        <div
                          style={{
                            padding: 0,
                            backgroundColor: "#F9F9FA",
                            position: "absolute",
                            top: "20%",
                            left: 1,
                          }}
                        >
                          <img
                            className="mb-0"
                            src={pinLocation}
                            alt="pinlocation"
                            style={{
                              objectFit: "contain",
                              marginRight: 10,
                              height: 30,
                              width: 30,
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: "10px 0px" }}>
                        <div
                          style={{
                            backgroundColor: "white",
                            padding: "18px 24px",
                            borderRadius: 5,
                            flex: 1,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: 14,
                            }}
                          >
                            <p
                              className="p-nunito"
                              style={{ margin: 0, color: "#1672BD" }}
                            >
                              {item.noRef}
                            </p>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <img
                              className="mb-0"
                              src={calendar}
                              alt="calendar"
                              style={{
                                objectFit: "contain",
                                height: 20,
                                width: 20,
                                marginRight: 10,
                              }}
                            />
                            <p className="p-nunito" style={{ margin: 0 }}>
                              Tanggal :{" "}
                              {moment(item.registeredDate).format("DD-MM-YYYY")}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 4,
                            }}
                          >
                            <img
                              className="mb-0"
                              src={calendar}
                              alt="calendar"
                              style={{
                                height: 20,
                                width: 20,
                                objectFit: "contain",
                                marginRight: 10,
                              }}
                            />
                            <p className="p-nunito" style={{ margin: 0 }}>
                              Masa Berlaku :
                              {item.isLifeTime
                                ? " Seumur Hidup"
                                : " " +
                                  moment(item.startDate).format("DD-MM-YYYY") +
                                  " s.d " +
                                  moment(item.endDate).format("DD-MM-YYYY")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <div
        style={{ position: "absolute", top: 34, right: 20, cursor: "pointer" }}
        onClick={closeModal}
      >
        <img
          className="mb-0"
          src={close}
          alt="close"
          style={{
            height: 25,
            width: 25,
            objectFit: "contain",
            marginRight: 10,
          }}
        />
      </div>
    </Modal>
  );
}
